$().ready(function() {

    $(".service ul li:last-child").css('margin-right', '0px')
    $(".top_top_right span:eq(1)").css('margin-left', '0.3rem')
    $(".top_bot_right p a:eq(0) img:eq(1)").css('display', 'none')
    $(".top_bot_right p a:eq(1) img:eq(1)").css('display', 'none')
    $(".top_bot_right p a:eq(2) img:eq(1)").css('display', 'none')
    $(".footer_left p a:eq(0) img:eq(1)").css('display', 'none')
    $(".footer_left p a:eq(1) img:eq(1)").css('display', 'none')
    $(".footer_left p a:eq(2) img:eq(1)").css('display', 'none')
    $(".search ul li:eq(0)").css('')
    $(".search ul li:eq(1)").css('display', 'none')
    $(".service ul li:eq(1)").css('margin-right', '0px')
    $(".service ul li:last-child").css('margin-right', '0px')
    $(".prodisplay ul li:eq(1)").css('margin-right', '0px')
    $(".prodisplay ul li:eq(3)").css('margin-right', '0px')
    $(".cpzx .ul2 li:eq(3)").css('margin-right', '0px')
    $(".cpzx .ul2 li:eq(7)").css('margin-right', '0px')
    $(".gywm_ad_c ul li:eq(1)").css('margin-right', '0px')
    $(".gywm_ad_c ul li:eq(3)").css('margin-right', '0px')
    $(".cgal ul li:eq(3)").css('margin-right', '0px')
    $(".cgal ul li:eq(7)").css('margin-right', '0px')
    $(".zxyy_right input:eq(3)").css('height', '72px')
    $(".lxwm_left p:eq(0) img").css('width', '0.6rem').css('height', '0.6rem')
    $(".lxwm_left p:eq(1) img").css('width', '0.6rem').css('height', '0.6rem')
    $(".lxwm_left p:eq(2) img").css('width', '0.43rem').css('height', '0.43rem').css('margin-left', '0.1rem').css('margin-right', '0.08rem')
    $(".lxwm_left p:eq(2)").css('border', 'none')
    $("#slides li:eq(0)").css('background', 'url(img/banner1.jpg)').css('background-size', '100% 100%')
    $("#slides li:eq(1)").css('background', 'url(img/banner2.jpg)').css('background-size', '100% 100%')
    $.fn.imgscroll = function(e) {
        var t = {
            speed: 40,
            amount: 0,
            width: 1,
            dir: "left"
        };
        return e = $.extend(t, e),
            this.each(function() {
                function t() {
                    (o += e.width) > i && (o = 0, n.parent().css("left" == e.dir ? {
                            left: -o
                        } : {
                            top: -o
                        }), o += e.width),
                        n.parent().animate("left" == e.dir ? {
                                left: -o
                            } : {
                                top: -o
                            },
                            e.amount)
                }
                var n = $("li", this);
                n.parent().parent().css({
                        overflow: "hidden",
                        position: "relative"
                    }),
                    n.parent().css({
                        margin: "0",
                        padding: "0",
                        overflow: "hidden",
                        position: "relative",
                        "list-style": "none"
                    }),
                    n.css({
                        position: "relative",
                        overflow: "hidden"
                    }),
                    "left" == e.dir && n.css({
                        float: "left"
                    });
                for (var i = 0,
                        r = 0; r < n.size(); r++) i += "left" == e.dir ? n.eq(r).outerWidth(!0) : n.eq(r).outerHeight(!0);
                "left" == e.dir && n.parent().css({
                        width: 3 * i + "px"
                    }),
                    n.parent().empty().append(n.clone()).append(n.clone()).append(n.clone()),
                    n = $("li", this);
                var o = 0,
                    a = setInterval(function() {
                            t()
                        },
                        e.speed);
                n.parent().hover(function() {
                        clearInterval(a)
                    },
                    function() {
                        clearInterval(a),
                            a = setInterval(function() {
                                    t()
                                },
                                e.speed)
                    })
            })
    }
    $(document).ready(function() {
        $(".dowebok1").imgscroll({
            speed: 40,
            amount: 0,
            width: 1,
            dir: "left"
        })
    })

    $(document).ready(function() {
        $(".dowebok2").imgscroll({
            speed: 40,
            amount: 0,
            width: 1,
            dir: "left"
        })
    })


});



$(function() {
    var numpic = $('#slides li').size() - 1;
    var nownow = 0;
    var inout = 0;
    var TT = 0;
    var SPEED = 5000;


    $('#slides li').eq(0).siblings('li').css({ 'display': 'none' });


    var ulstart = '<ul id="pagination">',
        ulcontent = '',
        ulend = '</ul>';
    ADDLI();
    var pagination = $('#pagination li');
    var paginationwidth = $('#pagination').width();

    pagination.eq(0).addClass('current')

    function ADDLI() {
        //var lilicount = numpic + 1;
        for (var i = 0; i <= numpic; i++) {
            ulcontent += '<li>' + '<a href="javascript:;">' + (i + 1) + '</a>' + '</li>';
        }

        $('#slides').after(ulstart + ulcontent + ulend);
    }

    pagination.on('click', DOTCHANGE)

    function DOTCHANGE() {

        var changenow = $(this).index();

        $('#slides li').eq(nownow).css('z-index', '900');
        $('#slides li').eq(changenow).css({ 'z-index': '800' }).show();
        pagination.eq(changenow).addClass('current').siblings('li').removeClass('current');
        $('#slides li').eq(nownow).fadeOut(400, function() { $('#slides li').eq(changenow).fadeIn(500); });
        nownow = changenow;
    }

    pagination.mouseenter(function() {
        inout = 1;
    })

    pagination.mouseleave(function() {
        inout = 0;
    })

    function GOGO() {

        var NN = nownow + 1;

        if (inout == 1) {} else {
            if (nownow < numpic) {
                $('#slides li').eq(nownow).css('z-index', '90');
                $('#slides li').eq(NN).css({ 'z-index': '80' }).show();
                pagination.eq(NN).addClass('current').siblings('li').removeClass('current');
                $('#slides li').eq(nownow).fadeOut(400, function() { $('#slides li').eq(NN).fadeIn(500); });
                nownow += 1;

            } else {
                NN = 0;
                $('#slides li').eq(nownow).css('z-index', '900');
                $('#slides li').eq(NN).stop(true, true).css({ 'z-index': '800' }).show();
                $('#slides li').eq(nownow).fadeOut(400, function() { $('#slides li').eq(0).fadeIn(500); });
                pagination.eq(NN).addClass('current').siblings('li').removeClass('current');

                nownow = 0;

            }
        }
        TT = setTimeout(GOGO, SPEED);
    }

    TT = setTimeout(GOGO, SPEED);

})



$(document).ready(function() {
    $(".menu").click(function() {
        $(".mask").slideToggle("slow");
        $(".nav").slideToggle("slow");
    })
});
